import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, Form, Button, Alert, Spinner, Fade } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
//import Footer from './Footer';
import { Helmet } from 'react-helmet';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setShowForm(true);
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (token !== 'oneFriendLeft') {
      setMessage({ text: 'Unauthorized access', type: 'danger' });

      // Redirect to home or a 404 page after 60 seconds
      setTimeout(() => navigate('/'), 60000);
    }
  }, [location, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await axios.post('http://localhost/login.php', {
        username,
        password,
      });

      if (response.data.success) {
        setMessage({ text: 'Login successful!', type: 'success' });
        navigate('/'); // Redirect to the home page after a successful login
      } else {
        setMessage({ text: response.data.msg, type: 'danger' });
      }
    } catch (error) {
      console.error('Error:', error);
      setMessage({ text: 'An error occurred. Please try again.', type: 'danger' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <Container className="flex">
        <Helmet>
          <title>Admin-Login</title>
        </Helmet>
        <h2>Admin Login</h2>
        <Fade in={!!message}>
          <div>
            {message && <Alert variant={message.type}>{message.text}</Alert>}
          </div>
        </Fade>
        <Fade in={showForm}>
          <div>
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="formUsername">
                <Form.Label className="chidi">Username</Form.Label>
                <Form.Control
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  disabled={loading}
                  placeholder="Username"
                />
              </Form.Group>
              <Form.Group controlId="formPassword">
                <Form.Label className="chidi">Password</Form.Label>
                <Form.Control
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                  placeholder="Password"
                />
              </Form.Group>
              <Button variant="secondary" type="submit" className="mt-3" disabled={loading}>
                {loading ? <Spinner animation="border" size="sm" /> : 'Login'}
              </Button>
            </Form>
          </div>
        </Fade>
      </Container>
    </div>
  );
};

export default Login;

